<template>
  <div>
    <m-layout-stack horizontal>
      <div class="flex-auto">
        {{ item.title }}
      </div>
    </m-layout-stack>
  </div>
</template>

<script setup lang="ts">
export type CommunicationThreadJournalItem = {
  subsequentCommunicationsCount: number;
  initialCommunicationChannelType: { label: string };
  title: string;
};

defineProps<{
  item: CommunicationThreadJournalItem;
  readOnly: boolean;
  contextHiddenFromPatientFacingServices?: boolean;
  contextConfidentialFromThirdPartyServices?: boolean;
}>();
</script>
